const API_VER = 'v1.0'
export const BaseEndpoints = {
  BEAT_URI: `/beat/api/${API_VER}/periodictasks/`,
  BASE_ADMIN_LOG_URI: `/base/api/${API_VER}/admin_log/`,
}
